export default __webpack_public_path__ + "static/media/North-America.de50a883.png";